import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { css } from "@emotion/react";
import { useLinks } from "hooks";
import { NarrowContainer, Row } from "components/Containers";
import { breakpoints, colors } from "style";
import { Link } from "components/Links";
import { MarketingSecondaryButton } from "components/Buttons";
import { BrandLogo } from "components/Logo";
import { BRAND_LOGO_VARIANTS } from "constants/brands";

/**
 * PublicHeader
 */
const PublicHeader = () => {
  const links = useLinks();

  return (
    <div css={styles.container}>
      <NarrowContainer>
        <Row css={styles.header}>
          <Link to={links.website}>
            <BrandLogo variant={BRAND_LOGO_VARIANTS.marketing} />
          </Link>
          <Row gap={`4rem`} css={styles.link_container}>
            <Link to={links.login}>
              <MarketingSecondaryButton>
                <FormattedMessage id="Missions.Roles.Public.PublicHeader.LoginLink" />            
              </MarketingSecondaryButton>
            </Link>
          </Row>
        </Row>
      </NarrowContainer>
    </div>
  );
}

const styles = {
  container: css`
    background: ${colors.white};
    padding: 2rem 0;    
  `,
  link_container: css`
    @media (max-width: ${breakpoints.mobile}) {
      gap: 1rem;
    }
  `,
  header: css`
    align-items:center;
    height:5rem;
    justify-content: space-between;
    position:relative;
    z-index:3;
  `,
};

PublicHeader.propTypes = {
  pages: PropTypes.array,
  children: PropTypes.node,
};

export default PublicHeader;
